module.exports = __webpack_public_path__ + "img/about-1.771d9c43.jpg";